//const url = "https://brilliantpro-backend.herokuapp.com/"
const _URL = "https://brilliantpro-backend.herokuapp.com/"
export { _URL };